const footerEl = document.querySelector( '.page-footer' );

/**
 * Footer copyright year
 * @description - Update copyright year in footer to current year
 * @function
 * @name footerCopyrightYear
 * @return {void}
 */
const footerCopyrightYear = () => {

	if ( !footerEl ) {

		return;

	}

	const footerCopyYearEl = footerEl.querySelector( '.page-footer-bottom__copy mark' );

	if ( !footerCopyYearEl ) {

		return;

	}

	footerCopyYearEl.textContent = new Date().getFullYear();

};

export { footerCopyrightYear };
